<div class="forgot-password-view">
  <div class="left-section">
    <div class="heading">Forgot your password?</div>
    <div class="accent-bar" aria-hidden="true"></div>
    <div class="sub-heading">No worries! Enter your email and we'll send you a reset link.</div>
    <form class="forgotpwd-form" [formGroup]="forgotPasswordForm">
      <label class="email-label" for="email">Email</label>
      <mat-form-field class="full-width" appearance="outline">
        <mat-icon matPrefix>email</mat-icon>
        <input #emailInput id="email" type="email" matInput formControlName="email" placeholder="your@company.com"
          aria-describedby="emailHelp">
        <mat-error
          *ngIf="forgotPasswordForm.get('email').hasError('email') && !forgotPasswordForm.get('email').hasError('required')">
          Please enter a valid email address
        </mat-error>
        <mat-error *ngIf="forgotPasswordForm.get('email').hasError('required')">
          Email is <strong>required</strong>
        </mat-error>
      </mat-form-field>
      <div id="emailHelp" class="sr-only">Enter your account email address to receive a reset link.</div>
      <button mat-flat-button color="primary" (click)="forgotPwdSumbit()" class="reset-btn"
        [disabled]="!forgotPasswordForm.valid || forgotPasswordForm.pristine || isDisabledBtn">
        <span class="btn-spinner" *ngIf="submitting"></span>
        {{ cooldownRemaining > 0 ? 'Resend in ' + cooldownRemaining + 's' : 'Send reset link' }}
      </button>
      <div class="inline-success" *ngIf="showInlineSuccess">{{ inlineMessage }}</div>
      <a class="back-login" routerLink="/login/employerLogin">
        <mat-icon>arrow_back</mat-icon>
        Back to login
      </a>
    </form>
  </div>
  <div class="right-section">
    <img src="../../../assets/forgotpasssword.svg" alt="Forgot password illustration" class="illustration" />
  </div>
</div>